import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/reports/purchase-invoice-list/-components/component"
import { PurchaseInvoiceParams } from "@/routes/(pharma)/_layout/reports/purchase-invoice-list/-data/model";
import { PurchaseInvoiceManySchema } from "@/routes/(pharma)/_layout/reports/purchase-invoice-list/-data/type";
import { Loading } from "@/layouts/loading";
import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { PurchaseInvoice } from "@/gen/purchase_invoice/common_pb";
import { Supplier } from "@/gen/suppliers/common_pb";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(pharma)/_layout/reports/purchase-invoice-list/")({
    component: Component,
    validateSearch: PurchaseInvoiceParams,
});
